// TODO Refactor 
import React, { Component } from 'react';
import { translate } from "react-translate";
import ReactFlagsSelect from 'react-flags-select';
//import css module
import 'react-flags-select/css/react-flags-select.css'

import { connect } from 'react-redux'
import { addLanguage, addRegister, addLogin } from '../../redux/actions/AppAction'
import LoginComponent from '../Login/LoginComponent'
import { isSignedIn, onSignOut } from '../../services/authService'
import RegisterComponent from '../Login/RegisterComponent'
import ResetComponent from '../Login/ResetComponent'

import avatar from '../../components/../assets/icons/avatar.png'

import {
    Link
} from 'react-router-dom'

import {
    Segment,
    Container,
    Menu,
    Flag,
    Select,
    Image,
    Dropdown,
    Modal,
    Button,
    Divider,
    Icon,
    Header,
    Sidebar,
    Responsive,
} from 'semantic-ui-react'

import './menu.css'

import logoMyTravo from '../../assets/icons/logoMyTravo.png';

const countryOptions = [
    { key: 'en_GB', name: 'GB', flag: 'gb', text: 'English', value: 'en_GB' },
    { key: 'fr_FR', name: 'FR', flag: 'fr', text: 'Français', value: 'fr_FR' },
    { key: 'es_ES', name: 'ES', flag: 'es', text: 'Español', value: 'es_ES' },
    { key: 'pt_PT', name: 'PT', flag: 'pt', text: 'Português', value: 'pt_PT' },
    { key: 'ru_RU', name: 'RU', flag: 'ru', text: 'Pусский', value: 'ru_RU' },
    { key: 'zh_CN', name: 'CN', flag: 'nz', text: '中国', value: 'zh_CN' },
    { key: 'de_DE', name: 'DE', flag: 'de', text: 'Deutsch', value: 'de_DE' },
    { key: 'it_IT', name: 'IT', flag: 'it', text: 'Italiano', value: 'it_IT' },
    { key: 'ja_JP', name: 'JP', flag: 'jp', text: '日本の', value: 'ja_JP' },
]

const mapStateToProps = state => ({
    app: state.app
})

const mapActionToProps = {
    addLanguage: addLanguage,
    addRegister: addRegister,
    addLogin: addLogin,
}

class ConnectedMenuComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            flag: this.props.app.lang,
            selectedLanguageIndex: this.findLanguageIndex(this.props.app.lang),
            visible: false
        }


        this.toggleVisibility = () => this.setState({ visible: !this.state.visible })


        this.onChange = this.onChange.bind(this);
        this.signOut = this.signOut.bind(this);
        this.addRegister = this.addRegister.bind(this);
        this.addLogin = this.addLogin.bind(this);
    }

    componentWillMount() {
        if (!isSignedIn() && (window.location.hash === '#/login')) {
            this.addLogin()
        }

        let flag = 'fr';
        let index = 1;

        for (var i = 0; i < countryOptions.length; i++) {
            if (countryOptions[i].key == this.props.app.lang) {
                flag = countryOptions[i].flag;
                index = i;
            }
        }

        this.setState({
            flag: flag,
            selectedLanguageIndex: index
        })
    }

    getCountryProperties(property) {
        var countryProperties = []
        for (var i = 0; i < countryOptions.length; i++) {
            countryProperties.push(countryOptions[i][property])
        }
        return countryProperties;
    }

    getCountryLabels() {
        var countryProperties = {}
        for (var i = 0; i < countryOptions.length; i++) {
            countryProperties[countryOptions[i].name] = countryOptions[i].text
        }
        return countryProperties;
    }

    findLanguageIndex(language) {
        for (var i = 0; i < countryOptions.length; i++) {
            if (countryOptions[i].key == language) {
                return i;
            }
        }
        return 0;
    }

    onChange(data) {
        let flag;
        let languageCode;
        let countryCode = data;
        let flagcode = 'fr';
        let index = 1;
        for (var i = 0; i < countryOptions.length; i++) {
            if (countryOptions[i].name === countryCode) {
                flagcode = countryOptions[i].flag;
                languageCode = countryOptions[i].value;
                index = i;
                break
            }
        }

        this.changeLanguage(languageCode);
        this.setState({
            flag: flagcode,
            selectedLanguageIndex: index,
        })
    }

    changeLanguage(lang) {
        this.props.addLanguage(lang);
    }

    signOut() {
        onSignOut();
        this.forceUpdate();
    }

    addRegister() {
        this.props.addRegister(true);
    }

    addLogin() {
        this.props.addLogin(true);
    }

    render() {

        const { visible } = this.state

        var segmentStyle = {
            backgroundColor: '#077cca',
            paddingTop: '5px',
            paddingBottom: '5px'
        }

        var menuitemStyle = {
            color: '#0964c1',
            fontWeight: 'bold',
        }

        var menuWhiteStyle = {
            paddingTop: '5px',
            paddingBottom: '5px'
        }

        const { t } = this.props
        let token = localStorage.getItem('USER_TOKEN');
        let name;
        if (token !== undefined && token !== null) {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace('-', '+').replace('_', '/');
            var tmp = JSON.parse(window.atob(base64));
            name = tmp['name'];

        }

        // const trigger = (
        //     <span>
        //         <Flag name={this.state.flag} />
        //         {countryOptions[this.state.selectedLanguageIndex].text}
        //     </span>
        // )


        return (
            <div>

<Segment.Group>
                <Responsive as={Segment} minWidth={1025} size='mini' inverted vertical style={segmentStyle}>
                    <Menu stackable size='mini' secondary inverted>
                        <Menu.Menu position='right'>
                            <Menu.Item ><Link id="menuTextTopRight" to='/cguv'>{t('cguv')}</Link></Menu.Item>
                            <Menu.Item ><Link id="menuTextTopRight" to='/Support'>{t('faq')}</Link></Menu.Item>
                        </Menu.Menu>
                    </Menu>
                </Responsive>
                <Responsive as={Segment} minWidth={1025} Segment vertical style={menuWhiteStyle}>
                    <Menu stackable secondary size='mini' borderless>
                        <Menu.Item>
                            <Link to="/">
                                <Image centered id="logo"
                                    src={logoMyTravo}
                                />
                            </Link>
                        </Menu.Item>
                        {/* <Menu.Item style={menuitemStyle}><Link to='/' id="menuItemText">{t("MenuItem1_title")}</Link></Menu.Item> */}
                        <Menu.Item style={menuitemStyle}><Link to='/functions' id="menuItemText">{t("MenuItem2_title")}</Link></Menu.Item>
                        <Menu.Item style={menuitemStyle}><Link to='/pro' id="menuItemText">{t("MenuItem4_title")}</Link></Menu.Item>
                        {
                            isSignedIn() ? (
                                <Menu.Item style={menuitemStyle}><Link to='/works' id="menuItemText">{t("MenuItem3_title")}</Link></Menu.Item>

                            ) : (
                                    <div></div>
                                )
                        }
                        {
                            isSignedIn() ? (

                                <Menu.Item style={menuitemStyle}><Link to='/lists' id="menuItemText">{t("MenuItem6_title")}</Link></Menu.Item>
                            ) : (
                                    <div></div>
                                )
                        }
                        {/* <Dropdown style={menuitemStyle} item text='Services'>
                            <Dropdown.Menu>
                                <Dropdown.Item style={menuitemStyle}><Link to='/'>Antonio</Link></Dropdown.Item>
                                <Dropdown.Item style={menuitemStyle}><Link to='/'>Cassano</Link></Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown> */}
                        {
                            isSignedIn() ? (
                                <Menu.Menu position='right'>
                                    <Menu.Item>
                                        <ReactFlagsSelect
                                            defaultCountry={countryOptions.filter(country => country.key === this.props.app.lang)[0].name}
                                            id='selectCountry'
                                            className='flag_dropdown'
                                            placeholder='Français'
                                            countries={this.getCountryProperties('name')}
                                            customLabels={this.getCountryLabels()}
                                            selectedSize={22}
                                            optionsSize={22}
                                            onSelect={this.onChange}
                                        />
                                    </Menu.Item>
                                    <Image id="avataryo" src={avatar} avatar />
                                    <Container style={{ width: 'auto', alignSelf: 'center' }}>
                                        <Header textAlign='center' id="accountName">
                                            <span>{t("Header1_title") + ", "}</span><span>{name !== undefined && name !== null ? (name) : ("")}</span>
                                        </Header>
                                    </Container>
                                    <Menu.Item>
                                        <Link to='/' >
                                            <Button fluid id="logout" onClick={this.signOut}>
                                                <span>{t("Button1_title")}</span>
                                            </Button>
                                        </Link>
                                    </Menu.Item>
                                </Menu.Menu>
                            ) : (
                                    <Menu.Menu position='right'>
                                        <Menu.Item>
                                            <ReactFlagsSelect
                                                defaultCountry={countryOptions.filter(country => country.key === this.props.app.lang)[0].name}
                                                id='selectCountry'
                                                className='flag_dropdown'
                                                placeholder='Français'
                                                countries={this.getCountryProperties('name')}
                                                customLabels={this.getCountryLabels()}
                                                selectedSize={22}
                                                optionsSize={22}
                                                onSelect={this.onChange}
                                            />
                                        </Menu.Item>
                                        <Menu.Item>
                                            <Button id="loginButton" onClick={this.addLogin}>
                                                <a id="menuButton2Text">{t("Button2_title")}</a></Button>
                                            <LoginComponent />
                                            <ResetComponent />
                                        </Menu.Item>
                                        <Menu.Item>
                                            <Button onClick={this.addRegister} size="massive" circular id="menuButton3">
                                                <a id="menuButton3Text">{t("Button3_title")}</a></Button>
                                            <RegisterComponent />
                                        </Menu.Item>
                                    </Menu.Menu>
                                )
                        }
                    </Menu>
                  </Responsive>


                  <Responsive as={Segment} maxWidth={1024} size='mini' inverted vertical style={segmentStyle}>
                      <Menu size='mini' secondary inverted>
                          <Menu.Menu position='right'>
                              <Menu.Item  ><Link id="menuTextTopRight" to='/cguv'>{t('cguv')}</Link></Menu.Item>
                              <Menu.Item ><Link id="menuTextTopRight" to='/Support'>{t('faq')}</Link></Menu.Item>
                          </Menu.Menu>
                      </Menu>
                  </Responsive>

                <Responsive as={Segment} maxWidth={1024} id="mainNav">

                <Icon name="content" onClick={this.toggleVisibility} id="menuIcon" size="large" />


                     <Sidebar
                       as={Menu}
                       animation='overlay'
                       direction='left'
                       visible={visible}
                       vertical
                       id="sidebarMenu"
                     >


                     <Icon name="close" onClick={this.toggleVisibility}  size="large" id="closeIcon" />



                     {
                         isSignedIn() ? (
                             <Menu.Menu id="menuAccount">
                                 <Menu.Item>
                                     <ReactFlagsSelect
                                         defaultCountry={countryOptions.filter(country => country.key === this.props.app.lang)[0].name}
                                         id='selectCountry'
                                         className='flag_dropdown'
                                         placeholder='Français'
                                         countries={this.getCountryProperties('name')}
                                         customLabels={this.getCountryLabels()}
                                         selectedSize={21}
                                         optionsSize={21}
                                         onSelect={this.onChange}
                                     />
                                 </Menu.Item>

                                 <Container id="accountContainer">
                                    <Image id="avataryo" src={avatar} avatar />
                                     <Header textAlign='center' id="accountName">
                                         <span>{t("Header1_title") + ", "}</span><span>{name !== undefined && name !== null ? (name) : ("")}</span>
                                     </Header>
                                 </Container>
                                 <Menu.Item>
                                     <Link to='/' >
                                         <Button fluid id="logout" onClick={this.signOut}>
                                             <span>{t("Button1_title")}</span>
                                         </Button>
                                     </Link>
                                 </Menu.Item>
                             </Menu.Menu>
                         ) : (
                                 <Menu.Menu id="menuAccount">
                                     <Menu.Item>
                                         <ReactFlagsSelect
                                             defaultCountry={countryOptions.filter(country => country.key === this.props.app.lang)[0].name}
                                             id='selectCountry'
                                             className='flag_dropdown'
                                             placeholder='Français'
                                             countries={this.getCountryProperties('name')}
                                             customLabels={this.getCountryLabels()}
                                             selectedSize={21}
                                             optionsSize={21}
                                             onSelect={this.onChange}
                                         />
                                     </Menu.Item>
                                     <Menu.Item>
                                         <Button id="loginButton" onClick={this.addLogin}>
                                             <a id="menuButton2Text">{t("Button2_title")}</a></Button>
                                         <LoginComponent />
                                         <ResetComponent />
                                     </Menu.Item>
                                     <Menu.Item>
                                         <Button onClick={this.addRegister} size="massive" circular id="menuButton3">
                                             <a id="menuButton3Text">{t("Button3_title")}</a></Button>
                                         <RegisterComponent />
                                     </Menu.Item>
                                 </Menu.Menu>
                             )
                     }

                     <Menu.Item style={menuitemStyle}><Link to='/' id="menuItemText">{t("MenuItem1_title")}</Link></Menu.Item>
                     <Menu.Item style={menuitemStyle}><Link to='/functions' id="menuItemText">{t("MenuItem2_title")}</Link></Menu.Item>
                     <Menu.Item style={menuitemStyle}><Link to='/pro' id="menuItemText">{t("MenuItem4_title")}</Link></Menu.Item>
                     {
                         isSignedIn() ? (
                             <Menu.Item style={menuitemStyle}><Link to='/works' id="menuItemText">{t("MenuItem3_title")}</Link></Menu.Item>

                         ) : (
                                 <div></div>
                             )
                     }
                     {
                         isSignedIn() ? (

                             <Menu.Item style={menuitemStyle}><Link to='/lists' id="menuItemText">{t("MenuItem6_title")}</Link></Menu.Item>
                         ) : (
                                 <div></div>
                             )
                     }

                      {
                         isSignedIn() ? (

                           <Menu.Item style={menuitemStyle}>
                            <Link to='/subs' id="menuItemText">{t("Protected_MenuItem4_title")}</Link>
                           </Menu.Item>


                         ) : (
                                 <div></div>
                             )
                     }
                     {
                         isSignedIn() ? (

                           <Menu.Item style={menuitemStyle}>
                            <Link to='/recherche' id="menuItemText">{t("Protected_MenuItem7_title")}</Link>
                           </Menu.Item>


                         ) : (
                                 <div></div>
                             )
                     }
                     {
                         isSignedIn() ? (

                           <Menu.Item style={menuitemStyle}>
                            <Link to='/settings' id="menuItemText">{t("Protected_MenuItem5_title")}</Link>
                           </Menu.Item>


                         ) : (
                                 <div></div>
                             )
                     }

                     {
                         isSignedIn() ? (

                           <Menu.Item style={menuitemStyle}>
                            <Link to='/contact' id="menuItemText">{t("Protected_MenuItem6_title")}</Link>
                           </Menu.Item>


                         ) : (
                                 <div></div>
                             )
                     }

                    {/* BIG MENU HERE ON MOBILE and IPAD*/}
                    <Responsive minWidth={1024}>
                     {/* {
                         isSignedIn() ? (

                             <Menu.Item style={menuitemStyle}>
                              <Link to='/homepage' id="menuItemText">{t("Protected_MenuItem1_title")}</Link>
                             </Menu.Item>

                         ) : (
                                 <div></div>
                             )
                     } */}

                     {
                         isSignedIn() ? (

                             <Menu.Item style={menuitemStyle}>
                              <Link to='/works' id="menuItemText">{t("Protected_MenuItem2_title")}</Link>
                             </Menu.Item>


                         ) : (
                                 <div></div>
                             )
                     }

                     {
                         isSignedIn() ? (

                           <Menu.Item style={menuitemStyle}>
                            <Link to='/lists' id="menuItemText">{t("Protected_MenuItem3_title")}</Link>
                           </Menu.Item>


                         ) : (
                                 <div></div>
                             )
                     }

                     {
                         isSignedIn() ? (

                           <Menu.Item style={menuitemStyle}>
                            <Link to='/subs' id="menuItemText">{t("Protected_MenuItem4_title")}</Link>
                           </Menu.Item>


                         ) : (
                                 <div></div>
                             )
                     }
                     {
                         isSignedIn() ? (

                           <Menu.Item style={menuitemStyle}>
                            <Link to='/recherche' id="menuItemText">{t("Protected_MenuItem7_title")}</Link>
                           </Menu.Item>


                         ) : (
                                 <div></div>
                             )
                     }
                     {
                         isSignedIn() ? (

                           <Menu.Item style={menuitemStyle}>
                            <Link to='/settings' id="menuItemText">{t("Protected_MenuItem5_title")}</Link>
                           </Menu.Item>


                         ) : (
                                 <div></div>
                             )
                     }

                     {
                         isSignedIn() ? (

                           <Menu.Item style={menuitemStyle}>
                            <Link to='/contact' id="menuItemText">{t("Protected_MenuItem6_title")}</Link>
                           </Menu.Item>


                         ) : (
                                 <div></div>
                             )
                     }

                     </Responsive>

                  </Sidebar>

                   <Link to="/">
                       <Image centered id="logo" src={logoMyTravo}/>
                   </Link>


                </Responsive>


  </Segment.Group>
            </div>
        );
    }
}
const MenuComponent = connect(mapStateToProps, mapActionToProps)(ConnectedMenuComponent);
export default translate("MenuComponent")(MenuComponent)



// WEBPACK FOOTER //
// ./src/components/Public/MenuComponent.js